module.exports = __webpack_public_path__ + "img/gsjj.3baada61.png";